"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = exports.SideNavigation = exports.SecondaryNavContainer = exports.PrimaryNavContainer = exports.NavContents = exports.Container = exports.CloseButton = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _coreSimpleGrid = require("@vfuk/core-simple-grid");
var _coreIconButton = require("@vfuk/core-icon-button");
var _coreMixins = require("@vfuk/core-mixins");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Spacer = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__Spacer",
  componentId: "sc-cdmxx7-0"
})(function () {
  return [];
});
exports.Spacer = Spacer;
var SideNavigation = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__SideNavigation",
  componentId: "sc-cdmxx7-1"
})(function (props) {
  return (0, _styledComponents.css)(["position:fixed;top:", "px;left:0;bottom:0;display:flex;width:100%;overflow:hidden;pointer-events:none;z-index:", ";"], props.topOffset, props.zIndex);
});
exports.SideNavigation = SideNavigation;
var Container = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__Container",
  componentId: "sc-cdmxx7-2"
})(function (props) {
  var iconButtonLocal = (0, _coreIconButton.iconButtonTheme)(props.theme);
  return (0, _styledComponents.css)(["width:calc((100% - ", "px) - ", "px);max-width:", "px;display:flex;position:relative;", ";", " ", "{width:100%;position:relative;overflow:hidden;", "}", "{position:absolute;top:0;left:0;height:100%;", "}"], iconButtonLocal.size[4].sm.buttonSize, props.theme.spacing.responsive[2].sm * 2, props.theme.gridConfig.springWidth, (0, _coreMixins.elevation)(true), _coreMixins.respondTo.md((0, _styledComponents.css)(["margin:0 auto;width:100%;", ";"], (0, _coreMixins.elevation)(false))), _coreSimpleGrid.SimpleGridStyles.SimpleGrid, _coreMixins.respondTo.md((0, _styledComponents.css)(["overflow:unset;"])), _coreSimpleGrid.SimpleGridStyles.SimpleGridColumn, _coreMixins.respondTo.md((0, _styledComponents.css)(["position:relative;display:flex;height:100%;"])));
});
exports.Container = Container;
var PrimaryNavContainer = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__PrimaryNavContainer",
  componentId: "sc-cdmxx7-3"
})(function (props) {
  return (0, _styledComponents.css)(["background:", ";position:relative;", ";border-radius:0 0 ", " 0;", ";display:flex;flex-direction:column;justify-content:flex-end;pointer-events:auto;z-index:", ";&::before{content:'';display:block;position:absolute;top:0;right:100%;left:-10000px;bottom:0;background:#fff;}"], props.topNavigationTheme.appearance[props.appearance].sideTray.level[1].backgroundColor, (0, _coreMixins.elevation)(true), props.theme.border.radius[2], (0, _coreMixins.spacing)('padding', 4), props.zIndex + 1);
});
exports.PrimaryNavContainer = PrimaryNavContainer;
var SecondaryNavContainer = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__SecondaryNavContainer",
  componentId: "sc-cdmxx7-4"
})(function (props) {
  return (0, _styledComponents.css)(["position:relative;display:flex;align-items:stretch;justify-content:center;flex-direction:column;height:100%;background:", ";", ";", ";", ";", ";border-radius:0 0 ", " 0;pointer-events:auto;z-index:", ";"], props.topNavigationTheme.appearance[props.appearance].sideTray.level[2].backgroundColor, (0, _coreMixins.advancedSpacing)('padding', [4, 4, 4, 8]), (0, _coreMixins.elevation)(true), (0, _coreMixins.spacing)('margin-left', -3), (0, _coreMixins.responsiveCalc)('width', '100%', '+', 3), props.theme.border.radius[2], props.zIndex);
});
exports.SecondaryNavContainer = SecondaryNavContainer;
var NavContents = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__NavContents",
  componentId: "sc-cdmxx7-5"
})(function (props) {
  return (0, _styledComponents.css)(["", ";transition:", "s all ease;display:flex;align-items:stretch;justify-content:center;flex-direction:column;flex-grow:1;", ""], (0, _coreMixins.spacing)('gap', 4), props.animationDuration / 1000, props.isTransitioning && (0, _styledComponents.css)(["opacity:0;transform:translateX(50px);", ""], _coreMixins.respondTo.md((0, _styledComponents.css)(["transform:translateX(-50px);"]))));
});
exports.NavContents = NavContents;
var CloseButton = _styledComponents["default"].div.withConfig({
  displayName: "SideNavigationstyle__CloseButton",
  componentId: "sc-cdmxx7-6"
})(function (props) {
  return (0, _styledComponents.css)(["position:absolute;", ";z-index:", ";pointer-events:auto;transition:", "s all ease;left:calc(100% + ", "px);", " ", " ", ""], (0, _coreMixins.responsivePosition)('top', 2), props.zIndex + 2, props.animationDuration / 1000, props.theme.spacing.responsive[2].sm, _coreMixins.respondTo.md((0, _styledComponents.css)(["left:calc(((100% / 12) * 5) + ", "px);"], props.theme.spacing.responsive[2].md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["left:calc(((100% / 12) * 6) + ", "px);"], props.theme.spacing.responsive[2].lg)), props.closeButtonPosition > 1 && (0, _styledComponents.css)(["", " ", " transform:rotate(180deg);"], _coreMixins.respondTo.md((0, _styledComponents.css)(["left:calc(((100% / 12) * 10) + ", "px);"], props.theme.spacing.responsive[2].md)), _coreMixins.respondTo.lg((0, _styledComponents.css)(["left:calc(((100% / 12) * 9) + ", "px);"], props.theme.spacing.responsive[2].lg))));
});
exports.CloseButton = CloseButton;